import type { RunVercelResult } from '@cli-types/next-adapter/vercel.js'

export function createdStoreId(result: RunVercelResult): string | undefined {
  return /Blob store created:[^(]*\((store_[A-Za-z0-9]+)\)/.exec(
    `${result.stdout}\n${result.stderr}`
  )?.[1]
}
